import { makeAxiosRequestV1Api } from 'utils/api';

export const getGenetics = (params = {}) => {
  return makeAxiosRequestV1Api('/genetics', { params }).then(response => response.resources);
};
